export const actions = {
  ADD: 'MESSAGES_SYSTEM_MESSAGE_ADD',
  REMOVE: 'MESSAGES_SYSTEM_MESSAGE_REMOVE',
  REMOVE_BY_TYPE: 'MESSAGES_SYSTEM_MESSAGE_REMOVE_BY_TYPE',
  CLEAR: 'MESSAGES_SYSTEM_MESSAGES_CLEAR',
};

export function add(notification) {
  return {
    type: actions.ADD,
    value: notification,
  };
}

export function remove(notificationId) {
  return {
    type: actions.REMOVE,
    value: notificationId,
  };
}

export function removeByType(type) {
  return {
    type: actions.REMOVE_BY_TYPE,
    value: type,
  };
}

export function clear() {
  return {
    type: actions.CLEAR,
  };
}



// WEBPACK FOOTER //
// ./src/store/messages/systemMessages/actions.js